module.exports = __webpack_public_path__ + "static/media/cricket-player-bg.69db7031.jpg";